import { Link, useNavigate, useParams } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const SettlementOfAccounts = () => {
  const { branchId, userId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [deliveryPoses, setDeliveryPoses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [NumberOfInvoices, setNumberOfInvoices] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [DeliveryInvoicesFilterModel, setDeliveryInvoicesFilterModel] = useState({
    branchId: branchId,
    userId: userId,
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    userId: userId,
    title: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  const navigate = useNavigate();

  const getGridData = async () => {
    const resp = await apiMethod.getDeliveryInvoices(DeliveryInvoicesFilterModel.branchId, DeliveryInvoicesFilterModel.userId, DeliveryInvoicesFilterModel.size, DeliveryInvoicesFilterModel.part);
    if (methods.showApiErrors(resp)) {
      DeliveryInvoicesFilterModel.total = resp.total;
      DeliveryInvoicesFilterModel.parts = methods.calcPageParts(resp.total, DeliveryInvoicesFilterModel.size);
      setDeliveryInvoicesFilterModel({ ...DeliveryInvoicesFilterModel });
      setGridData(resp.data);
      setTotalAmount(resp.totalPrice);
      setNumberOfInvoices(resp.total);
    }
  };

  const getDeliveryPos = async () => {
    const resp = await apiMethod.getUserPos(filterModel.branchId, filterModel.userId, filterModel.title, filterModel.size, filterModel.part);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setDeliveryPoses(resp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      await getDeliveryPos();
      setLoading(false);
    }
    bindData();
  }, [branchId, userId]);

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-flex justify-content-start align-items-baseline mb-3'>
              <Link to={`/sale/${branchId}/deliverySettlement`} className='link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                مدیریت پیک‌ها/ فاکتور های پیک
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>مدیریت پیک‌ها/ فاکتور های پیک</p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row g-1'>
                  {/* value={methods.addNumSeperator(paymentModel.extraAmount)} */}
                  {/* <div className='col-md-3'>
                    <label htmlFor="funit" className="form-label">انتخاب پوز</label>
                    <select
                      id="funit"
                      className="form-select form-select-md"
                    // value={filterModel.userId}
                    // onChange={(e) => {
                    //   filterModel.userId = e.target.value;
                    //   setFilterModel({ ...filterModel });
                    // }}
                    >
                      <option value={0}>همه‌ی پوزها </option>
                      {deliveryPoses.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div> */}
                  <div className='col-md-3'></div>
                  <div className='col-md-5 d-md-flex justify-content-center align-items-center'>
                    <p className='settlementTitle me-3'>تعداد فاکتورها: <span className='fw-bolder text-dark'>{NumberOfInvoices}</span></p>
                    <p className='settlementTitle'>مبلغ کل: <span className='fw-bolder text-dark'>{methods.addNumSeperator(totalAmount)}</span></p>
                  </div>
                  <div className='col-md-4 text-end'>
                    <button
                      onClick={() => navigate(`/sale/${branchId}/deliverySettlement/deliverySettlementDocument/${userId}`)}
                      className='btn btn-outline-purple custome-btn' type='button'>
                      <span className='align-middle d-inline-block'>ثبت سند</span> <i className="bi bi-plus-circle align-middle"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                <table className="table table-striped table-md " >
                  <thead className='align-middle'>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">شماره فاکتور</th>
                      <th scope="col vertical-center">مشتری</th>
                      <th scope="col vertical-center">موبایل</th>
                      <th scope="col vertical-center">کد اشتراک</th>
                      <th scope="col vertical-center">مبلغ</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">{((DeliveryInvoicesFilterModel.part - 1) * DeliveryInvoicesFilterModel.size) + index + 1}</th>
                        <td>{item.invoiceNumber}</td>
                        <td>{item.merchantName}</td>
                        <td>{item.merchantPhone}</td>
                        <td>{item.merchantCode}</td>
                        <td>{methods.addNumSeperator(item.totalFinalPrice)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };
  return (
    <>
      {renderItems()}
    </>
  );
}

export default SettlementOfAccounts;